var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5733 11.7803L15.3344 4.89236C15.1325 4.66587 14.8183 4.59859 14.5483 4.71296C14.2751 4.83069 14.0959 5.11101 14.0959 5.42272V8.7394H13.8562C8.69705 8.74165 4.5 13.2043 4.5 18.6895V20.2211C4.5 20.5754 4.73647 20.8703 5.0604 20.9522C5.11439 20.9667 5.16514 20.9746 5.21912 20.9746C5.49231 20.9746 5.75145 20.8064 5.8767 20.5395C7.22641 17.6691 9.93879 15.8863 12.96 15.8863H14.0991V19.2019C14.0991 19.5136 14.2784 19.7939 14.5526 19.9116C14.8226 20.0305 15.1357 19.9587 15.3376 19.7322L21.5765 12.8455C21.8432 12.5472 21.8432 12.0808 21.5733 11.7803Z",
    fill: "#258AFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForward);
export default __webpack_public_path__ + "static/media/forward.c33dbbbc9d902c3f6b2c90728f47c652.svg";
export { ForwardRef as ReactComponent };